module.exports = __webpack_public_path__ + "static/media/symptoms.752695c8.jpg";